/*
 * 全局配置
 * 文件描述：
 *    主要存放路径及接口相关
 *      iconUrl: 字体文件路径
 *    storageKey: 存入的 storage 的 key
 *      api: 系统接口相关
 */

// 访问接口URL
export const appUrl: string = String(import.meta.env.VITE_APP_URL);

// 访问接口URL

// App 环境
export const appMode = String(import.meta.env.MODE);

// 是否是生产环境
export const appIsProd = import.meta.env.PROD;

// 存储KEY
export const storageKey = {
    USER_TOKEN: 'user:token',
    USER_INFO: 'user:info',
    TEST_GONGAN_LOGID: 'test-gongan-logid',
    TEST_AUTO_SWITCH: 'test-auto-switch',
    backupTestId: (test_id: number, log_id: number) => {
        return `test-backup-${test_id}-${log_id}`
    },
    TEST_RUNNING_SECOND: 'test-running-seconds',
    TEST_IS_PAUSE: 'test-is-pause',
    TEST_SPEED_UP: 'test-speed-up',
    DOCS_MODE: 'docs-mode',
}

export const appFileExtensions = {
    images: ['jpg', 'jpeg', 'png', 'gif', 'JPG'],
    audio: ['mp3', 'm4a', 'wav', 'aac'],
    video: ['mp4', 'rm', 'rmvb', 'wmv']
}

/**
 * 是否是生产环境
 */
export const isProduction = () => {
    return appMode === 'prod';
}


export const SUBJECT_SINGLE_ID = 11 // 单选
export const SUBJECT_MULTI_ID = 12 // 多选
export const SUBJECT_FENXI_ID = 13 // 情景分析


export const subjects = [
    {
        id: SUBJECT_SINGLE_ID,
        title: '单项选择题',
    },
    {
        id: SUBJECT_MULTI_ID,
        title: '多项选择题',
    },
    {
        id: SUBJECT_FENXI_ID,
        title: '情境分析题',
    }
]

export const AppDef = {
    ERR_EXAM_NOT_MATCH: 100001
}

export const FEEDBACK_TYPE_CORRECT = 1;
export const FEEDBACK_TYPE_ASK = 2;


export const QUESTION_TYPE_MULTI = 2;  // 多选
export const QUESTION_TYPE_PARSE = 4;  // 多选